export default (value) => {
  if(!value)
    return null;

  return Buffer.from(value).toString('base64');
}
